import React from "react";

const ImageGalleryRow = ({ images }) => {
  return (
    <div className="gallery-row">
      {images.map((image, index) => (
        <div
          key={index}
          className="gallery-column"
          style={{
            backgroundImage: `url(${image.src})`,
          }}
        >
          <div className="gallery-caption">
            <span className="chip white">{image.caption}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageGalleryRow;
